// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Pencil_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm21.31 6.878-4.188-4.19a1.5 1.5 0 0 0-2.122 0L3.44 14.25A1.5 1.5 0 0 0 3 15.31v4.19A1.5 1.5 0 0 0 4.5 21h4.19a1.5 1.5 0 0 0 1.06-.44L21.31 9a1.5 1.5 0 0 0 0-2.122ZM8.69 19.5H4.5v-4.19l8.25-8.25 4.19 4.19ZM18 10.189 13.81 6l2.25-2.25 4.19 4.189Z',
  viewBox: '0 0 24 24',
  glyph: 'Pencil_Stroke2_Corner0_Rounded',
})

export const PencilLine_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm21.53 5.47-3-3a.75.75 0 0 0-1.06 0l-9 9a.75.75 0 0 0-.22.53v3a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .53-.22l9-9a.75.75 0 0 0 0-1.06Zm-9.84 8.78H9.75v-1.94l6-6 1.94 1.94Zm7.06-7.06-1.94-1.94L18 4.06 19.94 6ZM21 12v7.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-15A1.5 1.5 0 0 1 4.5 3H12a.75.75 0 0 1 0 1.5H4.5v15h15V12a.75.75 0 0 1 1.5 0Z',
  viewBox: '0 0 24 24',
  glyph: 'PencilLine_Stroke2_Corner0_Rounded',
})

export const PencilLine_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'm21.53 5.47-3-3a.75.75 0 0 0-1.06 0l-9 9a.75.75 0 0 0-.22.53v3a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .53-.22l9-9a.75.75 0 0 0 0-1.06Zm-9.84 8.78H9.75v-1.94l6-6 1.94 1.94Zm7.06-7.06-1.94-1.94L18 4.06 19.94 6ZM21 12v7.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-15A1.5 1.5 0 0 1 4.5 3H12a.75.75 0 0 1 0 1.5H4.5v15h15V12a.75.75 0 0 1 1.5 0Z',
  viewBox: '0 0 24 24',
  glyph: 'PencilLine_Stroke2_Corner2_Rounded',
})
